export default __webpack_public_path__ + "static/media/vendor_debit_note.3529f02e.xlsx";